import { watchDeleteLink } from './deleteLink';
import { watchFetchLinks } from './fetchLinks';
import { watchUpdateLink } from './updateLink';

export const linksSagas = [watchDeleteLink(), watchFetchLinks(), watchUpdateLink()];
